var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bill_addon clr" },
    [
      _c("standart", {
        key: "order_addon",
        attrs: {
          title: "Розпорядження",
          is_active_result: false,
          is_active_problem: false,
          is_active_title: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }